import React from 'react';
import * as R from 'ramda';
import { withRouter } from 'react-router-dom';

import AuthMenu from '@goeuro/app/client/user-profile-components/src/containers/AuthMenu';
import { Hamburger } from '@goeuro/app/client/frontend-components/src/Icons2/Hamburger';
import CurrencySwitcher from '@goeuro/app/client/frontend-components/src/CurrencySwitcher';
import LocaleSwitcher from '@goeuro/app/client/frontend-components/src/LocaleSwitcher';
import {
  useWhitelabel,
  useCobranding,
} from '@goeuro/app/client/b2b-components/src/hooks';
import SmartHeader from '@goeuro/app/client/b2b-components/src/components/smart-header/SmartHeader';

import { Container } from 'components/shared/container/Container.styled';
import { IsMobileContext } from 'contexts/mobile';
import { useGlobalState } from 'hooks';
import MobileHeader from './mobile-header';
import { HeaderProps } from './Header.props';
import * as Styled from './Header.styled';

const Header = ({ match }: HeaderProps) => {
  const { locale, setLocale, currency, setCurrency } = useGlobalState();
  const isMobile = React.useContext(IsMobileContext);
  const { wlData } = useWhitelabel();
  const { cobraData } = useCobranding();

  const [isPortal, setIsPortal] = React.useState(false);
  const openPortal = () => setIsPortal(true);
  const closePortal = () => setIsPortal(false);

  const showCurrencySwitcher = match.path !== '/help';

  const currencySwitcherProps = {
    selectedCurrencyISO: currency,
    restrictedISOList: wlData.enabledCurrencies,
    onChange: setCurrency,
  };

  const renderHeader = () => (
    <>
      {/* @ts-ignore */}
      <SmartHeader locale={locale} currency={currency}>
        <Styled.MobileHeader>
          <Hamburger width={24} height={24} onClick={openPortal} />
        </Styled.MobileHeader>

        <Styled.DesktopHeader>
          {!isMobile && wlData.backButtonLabel && wlData.backButtonLink && (
            <Styled.BackButton href={wlData.backButtonLink}>
              {wlData.backButtonLabel}
            </Styled.BackButton>
          )}
          {showCurrencySwitcher && (
            <Styled.RightSideItem>
              <CurrencySwitcher {...currencySwitcherProps} />
            </Styled.RightSideItem>
          )}
          <Styled.RightSideItem>
            <LocaleSwitcher
              selectedLocale={locale}
              restrictedLocaleList={wlData.enabledLocales}
              onChange={setLocale}
            />
          </Styled.RightSideItem>
          {wlData.enableUserProfile && (
            <Styled.RightSideItem>
              <AuthMenu />
            </Styled.RightSideItem>
          )}
        </Styled.DesktopHeader>
      </SmartHeader>
    </>
  );

  if (wlData?.customHeader) return renderHeader();

  return (
    <Styled.Holder
      backgroundColor={R.prop('backgroundColor', cobraData)}
      data-e2e="wlHeader"
    >
      {isMobile && (
        <MobileHeader
          showModal={isPortal}
          onClose={closePortal}
          lang={locale}
          wlData={wlData}
          currency={currency}
          setLang={setLocale}
          setCurrency={setCurrency}
          showCurrencySwitcher={showCurrencySwitcher}
        />
      )}
      <Container noPadding>{renderHeader()}</Container>
    </Styled.Holder>
  );
};

export default withRouter(Header);
